var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_18862)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#4B359F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_200_18862)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_200_18862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70702 11.4265C6.66919 12 6.60374 8.28853 6.96352 5.8172C6.97745 5.72153 6.84607 5.67862 6.79452 5.76041C-1.86335 19.4964 7.00823 31.3123 18.1842 31.3123C29.3664 31.3123 35.935 21.1421 27.7367 5.99573C27.6907 5.9108 27.5537 5.94565 27.5582 6.04211C27.6823 8.65144 26.5146 10.7613 24.0333 10.0828C20.5537 9.13118 24.1579 4.03057 18.6487 2.46445C18.5783 2.44443 18.5117 2.51357 18.5377 2.58198C19.4762 5.0483 18.8927 7.30632 15.9621 7.65365C13.0424 7.99971 12.2959 5.85892 13.0216 3.28471C13.0429 3.209 12.9611 3.14528 12.893 3.1846C9.21575 5.30709 12.9861 10.8075 9.70702 11.4265Z",
    fill: "#E79834"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_200_18862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0444 2.96316C19.3781 4.06957 19.4141 5.15455 19.0277 6.05114C18.5709 7.11089 17.5633 7.81997 16.0043 8.00476C14.45 8.18898 13.3682 7.713 12.8156 6.73749C12.3813 5.97059 12.3165 4.96289 12.514 3.89321C11.4398 4.86762 11.4416 6.33075 11.5063 7.8522C11.5089 7.91357 11.5116 7.97518 11.5143 8.03693C11.5486 8.81393 11.584 9.6148 11.4156 10.2634C11.3217 10.6251 11.1599 10.9627 10.8839 11.2335C10.6065 11.5057 10.2383 11.6862 9.77326 11.774C8.94115 11.931 8.26319 11.8013 7.73954 11.4268C7.22498 11.0587 6.90941 10.4897 6.72092 9.86423C6.45886 8.99465 6.42119 7.94503 6.48451 6.9653C2.83812 13.3485 3.0262 19.2031 5.36459 23.5158C7.83268 28.0677 12.7219 30.9546 18.1845 30.9546C23.6644 30.9546 27.958 28.4697 29.9046 24.1848C31.779 20.0588 31.5182 14.1739 27.8954 7.06004C27.8125 8.01107 27.5409 8.87317 27.0558 9.50904C26.7234 9.94475 26.2897 10.2742 25.755 10.4419C25.2216 10.6092 24.6126 10.6077 23.9398 10.4237C23.4565 10.2916 23.0777 10.0818 22.7839 9.80187C22.4908 9.52269 22.2986 9.18931 22.1658 8.83346C21.9662 8.29861 21.889 7.66583 21.8147 7.05629C21.7939 6.88524 21.7732 6.71601 21.7502 6.5513C21.6405 5.76828 21.4745 5.02345 21.0323 4.38135C20.6547 3.83302 20.0547 3.33061 19.0444 2.96316ZM18.8706 2.454C18.8705 2.45381 18.8704 2.45362 18.8704 2.45343C18.8704 2.45362 18.8705 2.45381 18.8706 2.454ZM18.2056 2.7064C18.0685 2.3463 18.4133 2.02566 18.7462 2.12029C20.1864 2.5297 21.071 3.18348 21.6181 3.97793C22.1583 4.7624 22.3416 5.64584 22.4546 6.45269C22.4825 6.65193 22.506 6.8437 22.5287 7.02818C22.6014 7.61981 22.6649 8.13655 22.8322 8.58478C22.9369 8.86539 23.0771 9.09885 23.2745 9.28686C23.4711 9.47418 23.7408 9.63191 24.1274 9.73764C24.6952 9.89291 25.1627 9.88222 25.5422 9.76319C25.9204 9.64458 26.2362 9.41071 26.4903 9.0776C27.0066 8.40085 27.2632 7.31679 27.2033 6.05693C27.1913 5.80553 27.3737 5.64727 27.5401 5.60442C27.7047 5.56205 27.9339 5.61038 28.0497 5.82438C32.1795 13.4541 32.6298 19.9054 30.5522 24.4789C28.4685 29.0657 23.8868 31.6659 18.1845 31.6659C12.4711 31.6659 7.33653 28.6449 4.7393 23.8548C2.13607 19.0537 2.10747 12.5279 6.49392 5.56871C6.62067 5.36761 6.84893 5.32725 7.01587 5.38266C7.18647 5.43928 7.35189 5.61791 7.31572 5.86637C7.13769 7.08926 7.07408 8.57102 7.40195 9.65899C7.56457 10.1986 7.81248 10.6044 8.15334 10.8482C8.4851 11.0855 8.9545 11.2047 9.64131 11.075C9.99606 11.008 10.2274 10.8812 10.3857 10.7258C10.5455 10.569 10.6559 10.3588 10.7271 10.0846C10.8674 9.54442 10.8373 8.84827 10.8019 8.02697C10.7998 7.97921 10.7977 7.93102 10.7956 7.88242C10.7239 6.19564 10.6687 4.05593 12.7155 2.87452C13.0606 2.67533 13.4719 2.99706 13.3642 3.37914C13.0122 4.62774 13.0419 5.69371 13.4346 6.38695C13.8038 7.03887 14.5551 7.46026 15.9205 7.29842C17.292 7.13587 18.0415 6.54228 18.3745 5.76961C18.7186 4.97122 18.6574 3.89364 18.2056 2.70641L18.5375 2.58011L18.2056 2.7064Z",
    fill: "#1F2024"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.2386 9.38793C16.8924 15.1172 8.92191 16.8648 6.3201 12.162C6.23548 12.009 5.99287 12.0405 5.96414 12.213C4.25054 22.4974 11.7209 30.8681 19.7155 30.4245C28.1448 29.9568 33.4197 17.4048 27.5259 11.7678C27.455 11.7 27.336 11.7097 27.2689 11.7813C21.8169 17.5846 21.0239 8.51855 15.3875 9.15532C15.2786 9.16762 15.2082 9.28265 15.2386 9.38793Z",
    fill: "#F2C95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 14.0642C19.6244 18.361 25.5305 18.8195 27.0479 15.2341C27.1159 15.0735 27.3623 15.0695 27.4137 15.2362C29.6782 22.5821 25.0425 29.4687 19.0978 29.9935C12.8065 30.549 7.56827 21.9052 11.2921 17.1132C11.3521 17.0361 11.4698 17.0284 11.5466 17.0887C16.1533 20.7058 15.814 14.0444 19.9987 13.857C20.1084 13.852 20.1937 13.9553 20.1797 14.0642Z",
    fill: "#F9E174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7032 22.0195C24.0961 22.0195 24.4242 22.3437 24.3209 22.7227C24.0123 23.8546 22.977 24.6868 21.7472 24.6868C20.5174 24.6868 19.4821 23.8546 19.1735 22.7227C19.0702 22.3437 19.3983 22.0195 19.7912 22.0195H23.7032Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 18.6521C13.0449 17.955 13.6204 17.3949 14.3173 17.4105C19.2206 17.5201 22.3351 17.5298 26.7738 17.416C27.4741 17.398 28.0541 17.9597 28.0541 18.6602C28.0541 19.3248 27.5302 19.8722 26.8662 19.8989C22.1677 20.0876 19.0444 20.0575 14.2413 19.891C13.5741 19.8678 13.0449 19.3196 13.0449 18.6521Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3336 16.6978C19.2281 16.8072 22.3309 16.8168 26.7559 16.7033C27.8534 16.6751 28.7658 17.5555 28.7658 18.6586C28.7658 19.7034 27.942 20.5659 26.8951 20.608C22.1743 20.7976 19.0326 20.7672 14.217 20.6002C13.1666 20.5638 12.334 19.701 12.334 18.6505C12.334 17.5524 13.2397 16.6733 14.3336 16.6978ZM14.3176 17.4089C13.6207 17.3933 13.0453 17.9534 13.0453 18.6505C13.0453 19.318 13.5745 19.8662 14.2416 19.8894C19.0448 20.0559 22.168 20.086 26.8666 19.8973C27.5306 19.8706 28.0545 19.3232 28.0545 18.6586C28.0545 17.9581 27.4745 17.3964 26.7742 17.4143C22.3354 17.5282 19.2209 17.5185 14.3176 17.4089Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 18.6521C13.9336 17.955 14.5091 17.3949 15.206 17.4105C20.1093 17.5201 23.2238 17.5298 27.6625 17.416C28.3628 17.398 28.9428 17.9597 28.9428 18.6602C28.9428 19.3248 28.4189 19.8722 27.7549 19.8989C23.0563 20.0876 19.9331 20.0575 15.1299 19.891C14.4628 19.8678 13.9336 19.3196 13.9336 18.6521Z",
    fill: "#EB0D18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2222 16.6978C20.1167 16.8072 23.2196 16.8168 27.6446 16.7033C28.7421 16.6751 29.6544 17.5555 29.6544 18.6586C29.6544 19.7034 28.8307 20.5659 27.7838 20.608C23.0629 20.7976 19.9213 20.7672 15.1056 20.6002C14.0552 20.5638 13.2227 19.701 13.2227 18.6505C13.2227 17.5524 14.1283 16.6733 15.2222 16.6978ZM15.2063 17.4089C14.5094 17.3933 13.9339 17.9534 13.9339 18.6505C13.9339 19.318 14.4631 19.8662 15.1303 19.8894C19.9334 20.0559 23.0567 20.086 27.7552 19.8973C28.4192 19.8706 28.9432 19.3232 28.9432 18.6586C28.9432 17.9581 28.3631 17.3964 27.6629 17.4143C23.2241 17.5282 20.1096 17.5185 15.2063 17.4089Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0718 17.0156H20.0278L19.0498 20.2164H17.0938L18.0718 17.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2222 16.6978C20.1167 16.8072 23.2196 16.8168 27.6446 16.7033C28.7421 16.6751 29.6544 17.5555 29.6544 18.6586C29.6544 19.7034 28.8307 20.5659 27.7838 20.608C23.0629 20.7976 19.9213 20.7672 15.1056 20.6002C14.0552 20.5638 13.2227 19.701 13.2227 18.6505C13.2227 17.5524 14.1283 16.6733 15.2222 16.6978ZM15.2063 17.4089C14.5094 17.3933 13.9339 17.9534 13.9339 18.6505C13.9339 19.318 14.4631 19.8662 15.1303 19.8894C19.9334 20.0559 23.0567 20.086 27.7552 19.8973C28.4192 19.8706 28.9432 19.3232 28.9432 18.6586C28.9432 17.9581 28.3631 17.3964 27.6629 17.4143C23.2241 17.5282 20.1096 17.5185 15.2063 17.4089Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_200_18862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8267 20.2314L4.36319 17.3652L2.33203 17.3652C2.92396 20.4128 5.04973 23.7833 7.12556 24.9226L8.95361 24.8289C9.65202 24.8444 10.2979 24.6121 10.8267 24.0762C12.0918 22.7945 12.041 20.8085 10.8267 20.2314Z",
    fill: "#E79834"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_200_18862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0578 17.1372C2.12536 17.0553 2.22601 17.0078 2.33221 17.0078L4.36336 17.0078C4.41302 17.0078 4.46213 17.0182 4.50753 17.0383L10.9711 19.9045C10.9729 19.9053 10.9747 19.9061 10.9764 19.9069C10.9775 19.9074 10.9785 19.9079 10.9796 19.9084C11.7436 20.2715 12.1051 21.0618 12.1123 21.8847C12.1195 22.7104 11.7773 23.6177 11.08 24.3243C10.4816 24.9307 9.74421 25.1972 8.95931 25.1829L7.14395 25.276C7.07804 25.2794 7.01248 25.2644 6.95462 25.2326C5.84325 24.6226 4.75346 23.44 3.87203 22.048C2.98707 20.6503 2.28871 19.0047 1.98309 17.4313C1.96284 17.327 1.99024 17.2192 2.0578 17.1372ZM2.77318 17.7191C3.09516 19.0655 3.70861 20.4603 4.47298 21.6675C5.29613 22.9675 6.27237 24.0157 7.21064 24.5604L8.93557 24.4719C8.94427 24.4715 8.95299 24.4714 8.9617 24.4716C9.56859 24.4851 10.1181 24.2864 10.5738 23.8247C11.1415 23.2494 11.4065 22.5228 11.401 21.8909C11.3955 21.2579 11.1261 20.7677 10.6782 20.5527L4.28805 17.7191L2.77318 17.7191Z",
    fill: "#1F2024"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 17.3652C3.16834 22.8634 6.19497 26.7041 8.78353 24.0762C10.0462 22.7944 9.9955 20.8085 8.78353 20.2314L2.33203 17.3652Z",
    fill: "#DE7E25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11646 17.0807C2.21977 17.0019 2.35785 16.9857 2.4766 17.0384L8.9281 19.9046C8.92941 19.9052 8.93072 19.9057 8.93202 19.9063C8.93356 19.907 8.93509 19.9078 8.93661 19.9085C9.69952 20.2718 10.0602 21.0621 10.0673 21.8847C10.0745 22.7102 9.73311 23.6175 9.03707 24.324C8.33214 25.0397 7.55442 25.3528 6.76036 25.2609C5.98191 25.1709 5.26128 24.6996 4.63629 24.0039C3.38813 22.6143 2.40455 20.2041 1.98061 17.4169C1.96107 17.2885 2.01316 17.1596 2.11646 17.0807ZM2.79403 17.9578C3.25044 20.3794 4.13464 22.381 5.16544 23.5285C5.72522 24.1517 6.29886 24.4915 6.84208 24.5544C7.36968 24.6154 7.941 24.4232 8.53035 23.8249C9.09696 23.2497 9.36156 22.523 9.35607 21.8909C9.35056 21.2576 9.08145 20.7674 8.63475 20.5526L2.79403 17.9578Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75605 22.0768C7.75605 22.7642 7.21867 23.3215 6.55576 23.3215C5.89286 23.3215 5.35547 22.7642 5.35547 22.0768C5.35547 21.3893 5.89286 20.832 6.55576 20.832C7.21867 20.832 7.75605 21.3893 7.75605 22.0768Z",
    fill: "#AF6017"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55594 21.1878C6.10153 21.1878 5.71128 21.5736 5.71128 22.077C5.71128 22.5803 6.10153 22.9661 6.55594 22.9661C7.01034 22.9661 7.40059 22.5803 7.40059 22.077C7.40059 21.5736 7.01034 21.1878 6.55594 21.1878ZM5 22.077C5 21.2054 5.68454 20.4766 6.55594 20.4766C7.42733 20.4766 8.11187 21.2054 8.11187 22.077C8.11187 22.9485 7.42733 23.6773 6.55594 23.6773C5.68454 23.6773 5 22.9485 5 22.077Z",
    fill: "#1F2024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16586 21.0185C6.8016 21.2292 6.55654 21.623 6.55654 22.0741C6.55654 22.5252 6.8016 22.919 7.16586 23.1297C6.98661 23.2334 6.7785 23.2928 6.55654 23.2928C5.8835 23.2928 5.33789 22.7472 5.33789 22.0741C5.33789 21.4011 5.8835 20.8555 6.55654 20.8555C6.7785 20.8555 6.98661 20.9148 7.16586 21.0185Z",
    fill: "#EDB146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45464 21.2231C6.02612 21.2736 5.69371 21.6381 5.69371 22.0801C5.69371 22.5222 6.02612 22.8867 6.45464 22.9372C6.29436 22.6907 6.20107 22.3964 6.20107 22.0801C6.20107 21.7639 6.29436 21.4696 6.45464 21.2231ZM4.98242 22.0801C4.98242 21.2107 5.68725 20.5059 6.55671 20.5059C6.84286 20.5059 7.11219 20.5825 7.34411 20.7167C7.454 20.7803 7.52167 20.8976 7.52167 21.0245C7.52167 21.1515 7.454 21.2688 7.34411 21.3324C7.08523 21.4821 6.91235 21.7612 6.91235 22.0801C6.91235 22.3991 7.08523 22.6782 7.34411 22.8279C7.454 22.8915 7.52167 23.0088 7.52167 23.1358C7.52167 23.2627 7.454 23.38 7.34411 23.4436C7.11219 23.5778 6.84286 23.6544 6.55671 23.6544C5.68725 23.6544 4.98242 22.9496 4.98242 22.0801Z",
    fill: "#1F2024"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_200_18862",
    x: 3.31055,
    y: 2.46094,
    width: 28.0957,
    height: 28.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.51148,
    dy: -1.06693
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_200_18862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_200_18862",
    x: 2.95508,
    y: 2.10352,
    width: 28.8066,
    height: 29.5625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.51148,
    dy: -1.06693
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_200_18862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_200_18862",
    x: 2.33203,
    y: 17.3652,
    width: 9.42383,
    height: 7.55664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.77821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_200_18862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_200_18862",
    x: 1.97656,
    y: 17.0078,
    width: 10.1367,
    height: 8.26953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.77821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_200_18862"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_18862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_200_18862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2296,
    height: 30.2296,
    fill: "white",
    transform: "translate(1.88867 1.89062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.32732efd67f83a9b1c8462c11d1db9b3.svg";
export { ForwardRef as ReactComponent };